module.exports = function(h, row, outlet_id) {
    if (_.isNull(row.quantity)) {
        return <i class="text-muted">N/A</i>;
    }

    return <span>{row.quantity}</span>;
};



// WEBPACK FOOTER //
// ./resources/assets/js/components/stock/composite-quantity.jsx